import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardContent,
  Divider,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  Avatar,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import {
  Person as PersonIcon,
  Logout as LogoutIcon,
  VpnKey as PasswordIcon,
  AccountCircle as AccountIcon,
} from "@mui/icons-material";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import PasswordChangeModal from "../PasswordChangeModal/PasswordChangeModal";
import showConfirmDialog from "../ShowConfirmDialog/ShowConfirmDialog";
import { fetchOrgCodeAndValidate } from "../../pages/login/indexedDBHelper";

const ProfileDropdown = ({ onLogout }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const [isPasswordModalOpen, setIsPasswordModalOpen] = useState(false);
  const [orgCode, setOrgCode] = useState("");
  const accessToken = sessionStorage.getItem("accessToken");
  const open = Boolean(anchorEl);

  useEffect(() => {
    fetchOrgCodeAndValidate((data) => {
      if (data) {
        setOrgCode(data.org_code);
      } else {
        console.error("Failed to fetch data from IndexedDB.");
      }
    });
  }, [accessToken]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handlePasswordChange = () => {
    setIsPasswordModalOpen(true);
    handleClose();
  };

  const handleLogout = async () => {
    const confirmed = await showConfirmDialog(
      "Are you sure you want to logout?",
    );
    if (confirmed) {
      onLogout();
    }
    handleClose();
  };

  const getUserInfo = () => {
    const name = sessionStorage.getItem("name");
    const roleType = sessionStorage.getItem("roleType");
    const facilityName = sessionStorage.getItem("facility_display_name");
    const salutation = sessionStorage.getItem("salutation");

    return {
      name: name || "User",
      roleType: roleType || "",
      facilityName: facilityName || "",
      salutation: salutation && salutation !== "null" ? salutation : "",
    };
  };

  const userInfo = getUserInfo();

  return (
    <>
      <IconButton
        onClick={handleClick}
        sx={{ color: "#fff" }}
        aria-controls={open ? "profile-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        <AccountCircleIcon />
      </IconButton>

      <Menu
        id="profile-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        PaperProps={{
          sx: {
            minWidth: 280,
            mt: 1,
            borderRadius: 2,
            boxShadow: "0 4px 20px rgba(0,0,0,0.15)",
          },
        }}
      >
        {/* Profile Header */}
        <Box sx={{ p: 2, pb: 1 }}>
          <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
            <Avatar
              sx={{
                bgcolor: "#0E3F66",
                width: 40,
                height: 40,
                mr: 2,
              }}
            >
              <AccountIcon />
            </Avatar>
            <Box>
              <Typography variant="subtitle1" fontWeight="bold">
                {userInfo.salutation} {userInfo.name}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {userInfo.roleType}
              </Typography>
            </Box>
          </Box>
          {userInfo.facilityName && (
            <Typography variant="body2" color="text.secondary" sx={{ ml: 7 }}>
              {userInfo.facilityName}
            </Typography>
          )}
          <Typography variant="body2" color="text.secondary" sx={{ ml: 7 }}>
            ORG Code :{" "}
            <Box
              component="span"
              sx={{ color: "text.primary", fontWeight: 600 }}
            >
              {orgCode || "-"}
            </Box>
          </Typography>
        </Box>

        <Divider />

        {/* Menu Items */}
        <MenuItem onClick={handlePasswordChange}>
          <ListItemIcon>
            <PasswordIcon fontSize="small" />
          </ListItemIcon>
          <ListItemText>Change Password</ListItemText>
        </MenuItem>

        <Divider />

        <MenuItem onClick={handleLogout} sx={{ color: "error.main" }}>
          <ListItemIcon>
            <LogoutIcon fontSize="small" color="error" />
          </ListItemIcon>
          <ListItemText>Logout</ListItemText>
        </MenuItem>
      </Menu>

      {/* Password Change Modal */}
      <PasswordChangeModal
        open={isPasswordModalOpen}
        onClose={() => setIsPasswordModalOpen(false)}
      />
    </>
  );
};

export default ProfileDropdown;
